import { useEffect } from 'react';

const FIVE_SECONDS = 5000;

/**
 * Hook to help facilitate polling an endpoint with useEffect.
 * Intentionally simple to suit or polling use cases in AppBuilder.
 * The delay _is_ configurable just in case, but defaults to five seconds.
 */
export function useDelayedCall({
  callback,
  shouldCall,
  delay = FIVE_SECONDS,
}: {
  callback: () => void;
  shouldCall: boolean;
  delay?: number;
}) {
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    if (shouldCall) {
      timeout = setTimeout(() => {
        callback();
      }, delay);
    }

    return () => clearTimeout(timeout);
  }, [delay, callback, shouldCall]);
}
